import { useContext } from 'react'
import { Box, Button, Checkbox, Grid } from '@mui/material'
import {
  GridColumnHeaderTitle,
  gridRowSelectionIdsSelector,
  gridRowSelectionStateSelector,
  Toolbar,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro'

import useSharedStyles from '../../../../utils/shared.styles'
import AccountsContext from '../../context'
import useAccountStyles from '../../index.styles'

import useStyles from './index.styles'
import { DeviceTableRow } from './types'

const TableToolbar = ({ selectableDevices }: { selectableDevices: DeviceTableRow[] }) => {
  const classes = useStyles
  const accountClasses = useAccountStyles
  const sharedClasses = useSharedStyles
  const apiRef = useGridApiContext()
  const { deviceAction, setDeviceAction, isScrolled, setDenseViewForTableMultiselect } = useContext(AccountsContext)
  useGridSelector(apiRef, gridRowSelectionStateSelector)
  const selectedIds = Array.from(useGridSelector(apiRef, gridRowSelectionIdsSelector).keys())

  const isChecked = selectedIds.length > 0
  const isIndeterminate = selectedIds.length > 0 && selectedIds.length < selectableDevices.length

  return (
    <Toolbar style={{ ...accountClasses.gridToolbar, position: isScrolled ? 'fixed' : 'static' }}>
      <Box sx={(theme) => ({ ...accountClasses.gridToolbarContainer(theme), ...(isScrolled ? { borderRadius: 0 } : {}) })}>
        <Grid container={true} size={12} sx={[sharedClasses.centerContentVertical, { justifyContent: 'space-between' }]}>
          <Grid container={true} size={6} sx={sharedClasses.centerContentVertical}>
            <Checkbox
              checked={isChecked}
              indeterminate={isIndeterminate}
              onChange={() => {
                if (!isChecked || (isChecked && isIndeterminate)) {
                  apiRef.current.selectRows(
                    deviceAction === 'move' ? [...selectableDevices.map((d) => d.id).slice(0, 10)] : [...selectableDevices.map((d) => d.id)],
                    true,
                    false
                  )
                } else apiRef.current.selectRows([], false, true)
              }}
              slotProps={{
                input: { 'aria-label': 'Select all' },
              }}
              sx={classes.gridToolbarCheckbox}
            />
            <div style={classes.gridToolbarTitleContainer}>
              <GridColumnHeaderTitle columnWidth={0} label={`${selectedIds.length} selected${deviceAction === 'move' ? ' (max 10)' : ''}`} />
            </div>
          </Grid>

          <Grid container={true} size={6} sx={[sharedClasses.centerContentVertical, { justifyContent: 'flex-end' }]}>
            <Button
              variant="contained"
              size="small"
              color="error"
              onClick={() => {
                apiRef.current.selectRows([], false, true)
                setDeviceAction(undefined)
                setDenseViewForTableMultiselect(false)
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Toolbar>
  )
}

export default TableToolbar
